import { Avatar, Card, CardHeader, CardLink } from '../../ui/Display/Display';
import { Button } from '../../ui/Button/Button';

/** Customer / supplier card with Call and WhatsApp buttons. */
export function PartyCard({ title = 'Customer', party, to, whatsappText }: { title?: string; party?: any; to?: string; whatsappText?: string }) {
  if (!party) return null;
  const digits = (party.phone ?? '').replace(/\D/g, '').slice(-10);
  const wa = `https://wa.me/91${digits}${whatsappText ? `?text=${encodeURIComponent(whatsappText)}` : ''}`;
  return (
    <Card>
      <CardHeader title={title} action={to && <CardLink to={to} arrow={false}>Open</CardLink>} />
      <div className="flex items-center gap-3 px-5 pt-4">
        <Avatar name={party.name} size={40} />
        <div className="min-w-0">
          <p className="truncate font-medium text-navy-900">{party.name}</p>
          <p className="truncate text-[13px] text-ink-500">{party.phone || 'No phone saved'}</p>
        </div>
      </div>
      {digits.length === 10 && (
        <div className="grid grid-cols-2 gap-2 p-5 pt-4">
          <Button variant="outline" size="sm" leftIcon="phone" onClick={() => (window.location.href = `tel:${digits}`)}>Call</Button>
          <Button variant="outline" size="sm" leftIcon="send" onClick={() => window.open(wa, '_blank', 'noopener')}>WhatsApp</Button>
        </div>
      )}
      {digits.length !== 10 && <div className="pb-5" />}
    </Card>
  );
}

export default PartyCard;
